module.exports = __webpack_public_path__ + "static/bsas001-c6920c8167bbc252b575434ec498886c.jpg";